<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <div class="dressup1">
        <img
          src="https://resource.3uplay.com/sys-feed/8edae003-6922-4f25-9b78-792c35b866294009818579895348604.webp"
          alt=""
        />
      </div>
      <div class="dressup2">
        <span>守護摩羯～</span>
        <img
          src="https://resource.3uplay.com/sys-feed/cd25d439-d4d2-43d9-95a8-18f4946e522e7331778984984510146.webp"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActivityBox',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #010119;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2 {
      position: absolute;
      font-size: 0;
      top: 1906px;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 43px;
        color: white;
        z-index: 1;
      }
    }
    .dressup1 {
      left: 245px;
      img {
        width: 194px;
        height: auto;
      }
    }
    .dressup2 {
      left: 522px;
      top: 1943px;
      span {
        font-size: 20px;
        color: black;
        display: inline-block;
        text-align: center;
        width: 270px;
      }
      img {
        width: 270px;
        height: auto;
      }
    }
  }
}
</style>
